<template>
  <div>
    <el-drawer
      :visible.sync="visible"
      v-if="visible"
      size="100%"
      direction="rtl"
      :wrapperClosable="false"
      :title="`k线梯度配置-${getPlatformDisplayName(form.platform)}`"
    >
      <div style="display: flex; padding-left: 10px; border-bottom: 1px solid #DCDFE6">
        <span style="color: #07bd54; font-size: 14px">{{ computIncome(form) }}</span>
        <span style="color: #f56c6c; font-size: 14px; margin-left: 5px"> {{ computLoss(form) }}</span>
      </div>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="120px"
        size="small"
        style="padding: 20px;"
      >
        <el-form-item label="多单" prop="orderLever">
          <el-switch v-model="form.pos_long">
          </el-switch>
        </el-form-item>
        <el-form-item label="空单" prop="orderLever">
          <el-switch v-model="form.pos_short">
          </el-switch>
        </el-form-item>
        <el-form-item label="触发波动幅度" prop="waveRate">
          <el-input
            v-model.number="form.wave_rate_min"
            type="number"
            placeholder="例如：2.00"
            style="width: 100%;"
          >
            <template slot="append">%</template>
          </el-input>
          <div style="height: 5px"></div>
          <el-input
            v-model.number="form.wave_rate_max"
            type="number"
            placeholder="例如：10.00"
            style="width: 100%;"
          >
            <template slot="append">%</template>
          </el-input>

          <div style="font-size: 12px; color: red; margin-top: 5px;">
            k线波动在区间内触发
            <br>
            例如设置范围2-10%，当前波动5%
          </div>
        </el-form-item>

        <el-form-item label="下单倍数" prop="orderLever">
          <el-input
            v-model.number="form.order_lever"
            type="number"
            placeholder="例如：5"
            style="width: 100%;"
          >
            <template slot="append">倍</template>
          </el-input>
        </el-form-item>

        <el-form-item label="下单金额" prop="orderAmount">
          <el-input
            v-model.number="form.order_amount"
            type="number"
            placeholder="例如：50"
            style="width: 100%;"
          >
            <template slot="append">U</template>
          </el-input>
        </el-form-item>

        <el-form-item label="止盈点数" prop="profitPercentage">
          <el-input
            v-model.number="form.profit_percentage"
            type="number"
            placeholder="例如：5"
            style="width: 100%;"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>

        <el-form-item label="止损点数" prop="lossPercentage">
          <el-input
            v-model.number="form.loss_percentage"
            type="number"
            placeholder="例如：5"
            style="width: 100%;"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading">
            {{ isEdit ? '更新' : '保存' }}
          </el-button>
          <el-button @click="closeDrawer">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import api from '@/api/api'

export default {
  name: 'KlineWaveConfigSave',
  data () {
    return {
      visible: false,
      loading: false,
      isEdit: false,
      form: {
        id: 0,
        platform: '',
        pos_long: true,
        pos_short: true,
        wave_rate_min: '',
        wave_rate_max: '',
        order_lever: '',
        order_amount: '',
        profit_percentage: '',
        loss_percentage: ''
      },
      rules: {
        wave_rate_min: [
          { required: true, message: '请输入触发波动幅度', trigger: 'blur' }
        ],
        wave_rate_max: [
          { required: true, message: '请输入触发波动幅度', trigger: 'blur' }
        ],
        order_lever: [
          { required: true, message: '请输入下单倍数', trigger: 'blur' },
          { type: 'number', min: 1, message: '下单倍数必须大于0', trigger: 'blur' }
        ],
        order_amount: [
          { required: true, message: '请输入下单金额', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '下单金额必须大于0', trigger: 'blur' }
        ],
        profit_percentage: [
          { required: true, message: '请输入止盈点数', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '止盈点数必须大于0', trigger: 'blur' }
        ],
        loss_percentage: [
          { required: true, message: '请输入止损点数', trigger: 'blur' },
          { type: 'number', min: 0, message: '止损点数不能小于0', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    computIncome (item) {
      if (parseFloat(item.order_lever) > 0 && parseFloat(item.order_amount) > 0 && parseFloat(item.profit_percentage)) {
        return `预估收益：${item.order_lever * item.order_amount * item.profit_percentage * 0.01}`
      }
      return ''
    },
    computLoss (item) {
      if (parseFloat(item.order_lever) > 0 && parseFloat(item.order_amount) > 0 && parseFloat(item.loss_percentage)) {
        if (parseFloat(item.order_lever) * parseFloat(item.loss_percentage) >= 100) {
          return '止损亏损：已超爆仓阈值！'
        }
        return `止损亏损：${item.order_lever * item.order_amount * item.loss_percentage * 0.01}`
      }
      return ''
    },
    show (row = null, preSelectedPlatform = '') {
      this.visible = true
      this.isEdit = !!row

      if (row) {
        // 编辑模式，填充表单数据
        this.form = {
          id: row.id,
          platform: row.platform,
          pos_long: !!row.pos_long,
          pos_short: !!row.pos_short,
          wave_rate_min: row.wave_rate_min,
          wave_rate_max: row.wave_rate_max,
          order_lever: row.order_lever,
          order_amount: row.order_amount,
          profit_percentage: row.profit_percentage,
          loss_percentage: row.loss_percentage
        }
      } else {
        // 新增模式，重置表单
        this.resetForm()
        if (preSelectedPlatform) {
          this.form.platform = preSelectedPlatform
        }
      }
    },

    resetForm () {
      this.form = {
        id: 0,
        platform: '',
        pos_long: true,
        pos_short: true,
        wave_rate_min: '',
        wave_rate_max: '',
        order_lever: '',
        order_amount: '',
        profit_percentage: '',
        loss_percentage: ''
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },

    closeDrawer () {
      this.visible = false
      this.resetForm()
    },

    // 获取平台显示名称
    getPlatformDisplayName (platform) {
      const platformNames = {
        okx: 'OKX',
        binance: 'Binance',
        mexc: 'MEXC',
        gate: 'Gate',
        bitget: 'Bitget',
        xt: 'XT'
      }
      return platformNames[platform] || platform
    },

    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true

          const submitData = {
            id: this.form.id,
            platform: this.form.platform,
            pos_long: this.form.pos_long ? 1 : 0,
            pos_short: this.form.pos_short ? 1 : 0,
            wave_rate_min: this.form.wave_rate_min,
            wave_rate_max: this.form.wave_rate_max,
            order_lever: this.form.order_lever,
            order_amount: this.form.order_amount,
            profit_percentage: this.form.profit_percentage,
            loss_percentage: this.form.loss_percentage
          }

          api.klineWaveConfigsSave(submitData).then(res => {
            if (res.code === 0) {
              this.$message.success({
                message: this.isEdit ? '更新成功' : '保存成功',
                customClass: 'phone-custom-message'
              })
              this.closeDrawer()
              this.$emit('successfn')
            } else {
              this.$message.error({
                message: res.message || `操作失败${res.message}`,
                customClass: 'phone-custom-message'
              })
            }
          }).catch(err => {
            this.$message.error({
              message: `操作失败:${err}`,
              customClass: 'phone-custom-message'
            })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.el-drawer__body {
  padding: 0;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-input-group__append {
  background-color: #f5f7fa;
  color: #909399;
  border-left: 0;
}

.el-select {
  width: 100%;
}
</style>
